/* eslint-disable react/prop-types */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import React, { useState } from 'react';
import { Alert, Button, Form, Offcanvas, Tab, Tabs } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { routePaths } from 'routes/routePaths';
import TooltipComponent from './TooltipComponent';

function NewContactForm() {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [showContent, setShowContent] = useState('');
  const [validated, setValidated] = useState(false);
  const [validated2, setValidated2] = useState(false);

  const handleClose = () => {
    setShow(false);

    setTimeout(() => {
      setShowContent('');
    }, 200);
  };

  const showHandler = contentToShow => {
    if (contentToShow) {
      setShow(true);
      setShowContent(contentToShow);
    }
  };

  const handleSubmit1 = event => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      navigate(routePaths.REVIEW_URL);
    }

    setValidated(true);
  };
  const handleSubmit2 = event => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      navigate(routePaths.REVIEW_URL);
    }

    setValidated2(true);
  };

  const ibanText = `IBANs are long account numbers used by banks for
  cross-border transfers. Each country structures this
  number differently, but it always starts with a 2
  digit country code (e.g. DE for Germany).`;

  return (
    <>
      <Tabs fill defaultActiveKey="Inside_Europe" id="uncontrolled-tab-example">
        <Tab eventKey="Inside_Europe" title="Inside Europe" className="mt-4">
          <div className="leftContent">
            <Form noValidate validated={validated} onSubmit={handleSubmit1}>
              <Form.Group controlId="fullName" className="mb-3">
                <Form.Label className="fw-normal mb-1">
                  Full name of the account holder
                </Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="First name"
                  className="py-2"
                />
                <Form.Control.Feedback type="invalid">
                  <FontAwesomeIcon icon="exclamation-circle" /> Name cannot be
                  empty.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="IBAN" className="mb-3">
                <Form.Label className="fw-normal mb-1">
                  IBAN
                  <span className="d-none d-md-inline-block">
                    <TooltipComponent
                      text={<p className="text-start mb-0">{ibanText}</p>}
                    />
                  </span>
                  <Button
                    onClick={() => showHandler('ibans')}
                    className="ms-1 p-0 lh-1 border-0 shadow-none bg-transparent text-600 fs--1 d-md-none"
                  >
                    <FontAwesomeIcon icon="exclamation-circle" />
                  </Button>
                </Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="DE12345678901234567890"
                  className="py-2"
                />
                <Form.Control.Feedback type="invalid">
                  <FontAwesomeIcon icon="exclamation-circle" /> Please specify
                  an IBAN.
                </Form.Control.Feedback>
              </Form.Group>
              <Button
                variant="primary"
                className="w-100 mt-5 rounded-5 h-48px"
                type="submit"
              >
                Confirm
              </Button>
            </Form>
          </div>
        </Tab>
        <Tab eventKey="Outside_Europe" title="Outside Europe" className="mt-5">
          <div className="rightContent">
            <Alert variant="warning">
              <Flex>
                <FontAwesomeIcon icon="exclamation-circle" size="3x" />
                <p className="ms-3 mb-0">
                  To send EUR to this account, we need to use the SWIFT network.
                  It's slower, so the transfer might take a day or two longer.
                  Also note that intermediary banks and your recipient's bank
                  might charge extra fees to the amount received.
                </p>
              </Flex>
            </Alert>
            <Form noValidate validated={validated2} onSubmit={handleSubmit2}>
              <Form.Group controlId="fullName" className="mb-3">
                <Form.Label className="fw-normal mb-1">
                  Full name of the account holder
                </Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="First name"
                  className="py-2"
                />
                <Form.Control.Feedback type="invalid">
                  <FontAwesomeIcon icon="exclamation-circle" /> Name cannot be
                  empty.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="SWIFT_BIC_code" className="mb-3">
                <Form.Label className="fw-normal mb-1">
                  SWIFT / BIC code
                </Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="BUKBGB22"
                  className="py-2"
                />
                <Form.Control.Feedback type="invalid">
                  <FontAwesomeIcon icon="exclamation-circle" /> Please specify a
                  BIC.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="IBAN_Account_number" className="mb-3">
                <Form.Label className="fw-normal mb-1">
                  IBAN / Account number
                  <span className="d-none d-md-inline-block">
                    <TooltipComponent
                      text={
                        <p className="text-start mb-0">
                          You can enter either an IBAN or account number.
                        </p>
                      }
                    />
                  </span>
                  <Button
                    onClick={() => showHandler('ibans_account_number')}
                    className="ms-1 p-0 lh-1 border-0 shadow-none bg-transparent text-600 fs--1 d-md-none"
                  >
                    <FontAwesomeIcon icon="exclamation-circle" />
                  </Button>
                </Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="BUKBGB22"
                  className="py-2"
                />
                <Form.Control.Feedback type="invalid">
                  <FontAwesomeIcon icon="exclamation-circle" /> Please enter an
                  IBAN or account number.
                </Form.Control.Feedback>
              </Form.Group>
              <Button
                variant="primary"
                className="w-100 mt-5 rounded-5 h-48px"
                type="submit"
              >
                Confirm
              </Button>
            </Form>
          </div>
        </Tab>
      </Tabs>

      <Offcanvas
        show={show}
        placement={'bottom'}
        onHide={handleClose}
        className="c-offcanvas-style"
      >
        <div className="offcanvas-close-line" />

        <Offcanvas.Body className="mt-4">
          {showContent === 'ibans' && (
            <p className="px-3 mb-0 fs--1">{ibanText}</p>
          )}
          {showContent === 'ibans_account_number' && (
            <p className="px-4 mb-0 fs--1">
              You can enter either an IBAN or account number.
            </p>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default NewContactForm;
